import { IQualification, IQualificationRequest } from "@/types/qualification";

export class Qualification implements IQualification {
  public id = 0;
  public name = "";
  public acquisition_at = "";

  public constructor(props?: IQualification) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
  }
}

export class QualificationRequest implements IQualificationRequest {
  public id = 0;
  public name = "";
  public acquisition_at = "";

  public constructor(props?: IQualification) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
  }
}
